import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import { IconButton, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";

import HNSColors from "../../../../../ui library/HNSColors";

export default function ParentEntityLink({ entity }) {
  if (!entity?.id || !entity?.label) {
    return null;
  }

  return (
    <Tooltip placement="top" title="Open Parent Entity">
      <IconButton
        component={Link}
        id={`parent-entity-link-${entity.id}`}
        sx={{
          borderRadius: "8px",
          color: HNSColors.primary[500],
          height: "40px",
          width: "40px",
          "&:hover": {
            backgroundColor: HNSColors.tertiary[900],
          },
          "&:focus-visible": {
            outline: "none",
          },
        }}
        to={`/entity/${entity.id}`}
      >
        <OpenInNewOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
